import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);

export const formattedDate = (date: any) => {
  if (!date || date == "" || date == "null" || date == "undefined") return "";
  return dayjs(date).format("DD-MM-YYYY");
  //   return dayjs(date).format("DD MMMM YYYY");
};



// formatDateDDMMMMYYYY
export function formatDateDDMMMMYYYY(date: string): string {
  if (!date) return "";

  let parsed = dayjs(date);
  if (!parsed.isValid()) {
    parsed = dayjs(date, ["YYYY-MM-DD", "DD-MM-YYYY", "DD/MM/YYYY"], true);
  }

  return parsed.isValid() ? parsed.format("D MMMM YYYY") : "";
}
